import { OcPopover, SystemIcon, useOcPopover } from '@utmost.co/utmost-design-system';
import { FieldPermission } from '../../../forms';
import React, { FC } from 'react';
import styled from 'styled-components';
import { useSmartFormPermissionContext } from '../SmartformPermissionContext';
import { PermissionsCard } from './PermissionsCard';

interface Props {
  permission?: FieldPermission;
  resourceUid?: string;
}

export const PermissionsInformation: FC<Props> = ({ permission, resourceUid }) => {
  const popover = useOcPopover();

  const { getPolicy } = useSmartFormPermissionContext();

  const isCustomField =
    permission?.PERMISSION_NAME?.includes('.CF') || permission?.PERMISSION_NAME?.includes('CUSTOM_FIELD');

  return (
    <StyledContainer disabled={isCustomField}>
      <StyledSystemIcon
        onClick={(event) => {
          getPolicy(resourceUid, permission);
          popover.toggle(event);
        }}
        size={16}
        name="info"
      />
      <OcPopover
        open={popover.open}
        anchorEl={popover.anchorEl}
        onClose={popover.close}
        PaperProps={{ style: { borderRadius: '5px' } }}
      >
        <PermissionsCard resourceUid={resourceUid} permission={permission} />
      </OcPopover>
    </StyledContainer>
  );
};

const StyledContainer = styled.div<{ disabled?: boolean }>`
  position: relative; 
  display: ${(props) => (props.disabled ? 'none' : 'flex')};
  flex-direction: column;
  align-items: center;
  justify-content: center;  
`;

const StyledSystemIcon = styled(SystemIcon)`
  cursor: pointer;
`;
